import gsap from "gsap";

const dialog = document.getElementById("ack_dialog");
const button = document.getElementById("ack_btn");

// Check if acknowledgment exists in sessionStorage
if (!sessionStorage.getItem("respect_2040_acknowledged")) {
	document.body.classList.add("mobile-no-scroll");
	dialog.showModal();
	gsap.set(dialog, { opacity: 0 });
	gsap.to(dialog, {
		opacity: 1,
		duration: 0.6,
		ease: "power1.out",
	});
}

button.addEventListener("click", function () {
	document.body.classList.remove("mobile-no-scroll");
	gsap.to(dialog, {
		opacity: 0,
		duration: 0.5,
		ease: "power1.in",
		onComplete: () => {
			dialog.close();
		},
	});

	sessionStorage.setItem("respect_2040_acknowledged", "true");
});
